import { ITealiumAnalyticsOptions } from './tealium-analytics-options';

export class TealiumAnalyticsEvent {
	constructor(private eventName: string, private options: ITealiumAnalyticsOptions = {}) { }

	public getEventName(): string {
		return this.eventName;
	}

	public setEventName(name: string): TealiumAnalyticsEvent {
		if (this.eventName) {
			this.eventName = name;
		}
		return this;
	}

	public getOptions(): ITealiumAnalyticsOptions {
		return this.options;
	}

	public setOptions(propertyKey: string, propertyValue: string): TealiumAnalyticsEvent {
		if (this.options) {
			this.options[propertyKey] = propertyValue;
		}
		return this;
	}
}
